import { useNavigate, useLocation, useParams } from 'react-router-dom';
// Bootstrap removed - using Tailwind-only approach
import React, { useEffect, useState, useRef } from 'react';
import AccountDetailContainerWrapper from '../components/account-details/AccountDetailContainerWrapper.jsx';
import { useUserContext } from "../context/UserContext";

export default function AccountDetails() {
    const { setLeadId } = useUserContext();
    const { setUserId } = useUserContext();
    const { leadId } = useUserContext()
    const[leadID, setLeadID] = useState("")
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams()
    const [buttonText, setButtonText] = useState("Click Me");

    useEffect(() => {
        const queryString = window.location.search;
        const queryParams = new URLSearchParams(queryString)
        setLeadId(queryParams.get("lead_id") || "No lead ID found")
        // use query params instead of user context lead id
        setLeadID(queryParams.get("lead_id") || "No lead ID found")
    }, []);

    return (
        <>
        <AccountDetailContainerWrapper leadID={leadID}/>
        </>
    );
}